import React, { useEffect } from 'react';
import './rollback-version.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { NavLink } from 'react-router';
import Grid from '../../../components/base/Grid/Grid';
import Pagination from '../../../components/base/Pagination/Pagination';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { getPaginationOpts, getResponseError, responseLogWithNotification } from '../../../utils/utils';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { errorNotification } from '../../Notifications/notificationDecorator';
import {
  checkStatusRollbackPlansLoop,
  loadRollbackPlans, loadRollbackPlansClear, rollbackVersion,
} from '../actions';
import { localeFormatter } from '../../../utils/formatters';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import TextInput from '../../../components/fields/TextInput/TextInput';
import { getRollbackVersionData } from '../reducer';
import { APPLICATION_SUBJECT_TYPES, SUBJECT_TYPE } from '../../../configs';
import TimerLoader from '../../../components/base/Loader/TimerLoader';

export function RollbackPlanDialog(props) {
  const dispatch = useDispatch();
  const {
    onClose = () => {},
    rollbackPlanId,
    isPreload = false, // В случае если ранее уже была запущена процедура создания плана
  } = props;
  const {
    rollbackPlanList,
    rollbackPlanListMeta,
    loadingRollbackPlanList,
    loadingStatusLoopRollbackPlan,
  } = useSelector(getRollbackVersionData);

  const { control, getValues } = useForm({});

  const rollback = () => {
    dispatch(rollbackVersion({ id: rollbackPlanId, data: getValues() })).catch(response => {
      errorNotification('Уведомления', getResponseError(response));
    });
    onClose();
  };

  const loadData = opts => {
    const paginationOpts = getPaginationOpts(rollbackPlanListMeta, opts);
    const requestData = {
      ...paginationOpts,
      id: rollbackPlanId,
    };
    const p1 = dispatch(loadRollbackPlans(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  useEffect(() => {
    dispatch(loadRollbackPlansClear()).catch(responseLogWithNotification);
    if (rollbackPlanId && !isPreload) {
      dispatch(checkStatusRollbackPlansLoop(rollbackPlanId)).then(() => loadData()).catch(response => {
        errorNotification('Уведомления', getResponseError(response));
      });
    } else {
      loadData();
    }
  }, []);

  const columns = [
    {
      dataField: 'audit',
      text: 'Тип объекта',
      headerClassName: 'user-column',
      formatter: item => localeFormatter('subject.type', item?.auditable_type),
      disableSort: true,
    },
    {
      dataField: 'audit',
      text: 'Номер объекта',
      headerClassName: 'date-time-column',
      formatter: (audit, item) => {
        const { auditable_type, auditable_id } = audit;
        const { meta = {} } = item;
        return (
          <>
            {APPLICATION_SUBJECT_TYPES.includes(auditable_type) ? <NavLink target="_blank" to={`/application?application_id=${auditable_id}`}>{localeFormatter('subject.type', auditable_type)} № {meta?.item_number || 'Без номера'}</NavLink> : null}
            {auditable_type === SUBJECT_TYPE.CARRIER ? <NavLink target="_blank" to={`/region-registry-carrier?registry_id=${auditable_id}`}>{localeFormatter('subject.type', auditable_type)} № {meta?.item_number || 'Без номера'} </NavLink> : null}
            {auditable_type === SUBJECT_TYPE.ORDER_SERVICE ? <NavLink target="_blank" to={`/region-registry/szlt?registry_id=${auditable_id}`}>{localeFormatter('subject.type', auditable_type)} № {meta?.item_number || 'Без номера'}</NavLink> : null}
            {auditable_type === SUBJECT_TYPE.VEHICLE ? <NavLink target="_blank" to={`/region-registry/passenger-taxi?registry_id=${auditable_id}`}>{localeFormatter('subject.type', auditable_type)} № {meta?.item_number || 'Без номера'}</NavLink> : null}
            {auditable_type === SUBJECT_TYPE.DOCUMENT ? <NavLink target="_blank" to={`/application/await-document?document_id=${auditable_id}`}>{localeFormatter('subject.type', auditable_type)} № {meta?.item_number || 'Без номера'}</NavLink> : null}
          </>
        );
      },
      disableSort: true,
    },
    {
      dataField: 'meta',
      text: 'Изменение версии',
      headerClassName: 'module-column',
      formatter: item => item?.item_changes,
      disableSort: true,
    },
    // {
    //   dataField: 'version_number',
    //   text: 'Новая версия',
    //   headerClassName: 'module-column',
    //   disableSort: true,
    // },
  ];

  return (
    <Dialog
      className="rollback-plan-dialog"
      onClose={onClose}
      open
    >
      <DialogTitle
        header="Восстановление версии и связи объектов"
        title={<Icons onClick={onClose} customIcon icon="close" className="close" />}
      />
      <DialogContent className="rollback-plan-dialog-content">
        <TimerLoader loading={loadingStatusLoopRollbackPlan || loadingRollbackPlanList} />
        <div className="rollback-plan-dialog-table  custom-scroll-theme">
          <Grid
            data={rollbackPlanList}
            columns={columns}
            name="rollback-plan-dialog-list"
          />
          <Pagination meta={rollbackPlanListMeta} list={rollbackPlanList} handleChangeMeta={loadData} />
        </div>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            component={TextInput}
            textarea
            dtoObject={{
              name: 'message',
              type: String,
              validators: {},
              labelKey: 'rejection_reason_note',
            }}
            placeholder=""
            withLabel
            variant="material"
          />
        </Row>
      </DialogContent>
      <DialogFooter>
        <Button className="hff-clear-data" variant="secondary" onClick={onClose}>Отменить</Button>
        <Button className="hff-clear-show" onClick={rollback} disabled={loadingStatusLoopRollbackPlan}>Подтвердить</Button>
      </DialogFooter>
    </Dialog>
  );
}
